// extracted by mini-css-extract-plugin
export default {"favoriteWrap":"favoriteToggle-favoriteWrap__Kts5P"};